import useCurrentStep from "../../../hooks/useCurrentStep";
import { Box, Container, Tab, Tabs } from "@mui/material";
import Loader from "../../../components/common/Loader";
import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Confirmation from "./Confirmation";
import Credentials from "./Credentials";
import Experties from "./Experties";
import Details from "./Details";
import Profile from "./Profile";
import { steps } from "./data";

function Signup() {
  const currentStep = useCurrentStep();
  const [value, setValue] = useState(currentStep);
  const { specialist } = useSelector((state) => state.specialistSlice);

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(currentStep);
  }, [currentStep]);

  return (
    <Fragment>
      <Box sx={{ py: 5 }} component="section">
        <Container maxWidth={false} fixed>
          <Tabs
            value={value}
            variant="scrollable"
            sx={{
              p: 2,
              pb: "0",
              bgcolor: "#8ebfe1",
              borderRadius: "6px 6px 0 0",
              border: "1px solid #3498db",
              borderBottom: "none",
              ".MuiTabs-flexContainer": { gap: 1 },
              ".MuiTabs-indicator": { display: "none" },
              "button.Mui-selected": { bgcolor: "#3498db", color: "white" },
              "button:has(~ .Mui-selected)": {
                bgcolor: "white",
                borderColor: "white",
                color: "primary.main",
              },
            }}
          >
            {steps?.map((step, i) => (
              <Tab
                sx={{
                  py: "14px",
                  flexGrow: "1",
                  color: "white",
                  cursor: "auto",
                  fontSize: "16px",
                  fontWeight: "500",
                  minHeight: "auto",
                  flexDirection: "row",
                  alignItems: "center",
                  fontFamily: "Poppins",
                  borderRadius: "5px 5px 0 0",
                  textTransform: "capitalize",
                  border: "1px solid #3498db",
                  flexBasis: { xs: "auto", md: "0" },
                  borderBottom: "0",
                  ".MuiTab-icon": {
                    mb: "0",
                    mr: 0.75,
                    fontSize: "18px",
                  },
                }}
                key={i}
                disableRipple
                label={step?.name}
                value={step?.value}
              />
            ))}
          </Tabs>

          <TabPanel value={value} index="login">
            <Credentials handleChange={handleChange} />
          </TabPanel>
          <TabPanel value={value} index="expertise">
            <Experties handleChange={handleChange} />
          </TabPanel>
          <TabPanel value={value} index="background">
            <Details handleChange={handleChange} />
          </TabPanel>
          <TabPanel value={value} index="profile">
            <Profile handleChange={handleChange} />
          </TabPanel>
          <TabPanel value={value} index="confirmation">
            <Confirmation />
          </TabPanel>
        </Container>
      </Box>

      {specialist?.loadingSignup && <Loader />}
    </Fragment>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{ height: "100%" }}
      hidden={value !== index}
      id={`tabpanel-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

export default Signup;
